export default __webpack_public_path__ + "static/media/roof.301b22d6.jpg";